import { render } from "./ButtonComponent.vue?vue&type=template&id=7cfe99b9&scoped=true&ts=true"
import script from "./ButtonComponent.vue?vue&type=script&lang=ts"
export * from "./ButtonComponent.vue?vue&type=script&lang=ts"

import "./ButtonComponent.vue?vue&type=style&index=0&id=7cfe99b9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cfe99b9"]])

export default __exports__